export default "__VITE_ASSET__9TSHUUpU__"